export function initFichesTechniques(){

	var fichesTechniques = Barba.BaseView.extend({
		namespace: 'fiches-techniques',
    onEnter: function () {
      // The new Container is ready and attached to the DOM.
      
      const allCategoriesSections = document.querySelectorAll(".category");

      const showItems = (showAllLink, listItemsChildren) => {
        showAllLink.addEventListener("click", (e) => {
          e.preventDefault();

          // On supprime les inline styles
          [...listItemsChildren].forEach(child => {
            child.classList.contains("not--displaying") && child.classList.toggle("is--active");
          });

          // On change le textContent du link show all
          showAllLink.textContent === "Afficher plus" ?
            showAllLink.textContent = "Afficher moins" :
            showAllLink.textContent = "Afficher plus";
        });
      }
      
      [...allCategoriesSections].forEach((section, index) => {
        const subcategories = section.querySelectorAll(".sub-category");
        
        // Si la section a une ou des subcategories
        if (subcategories.length > 0) {
          subcategories.forEach(subcategory => {
            // On récupère le link show all
            const showAllLink = subcategory.querySelector(".show-all");
            const listItems = subcategory.querySelector(".files-list");
            const listItemsChildren = listItems.children;

            if (showAllLink && listItems) {
              showItems(showAllLink, listItemsChildren);
            }
          })
        } else {
          const showAllLink = section.querySelector("a.show-all");
          const listItems = section.querySelector(".files-list");
          const listItemsChildren = listItems.children;

          if (showAllLink && listItems) {
            showItems(showAllLink, listItemsChildren);
          }
      }
    })
	},
	onEnterCompleted: function() {
		// The Transition has just finished.
	}
});
  // Don't forget to init the view!
  fichesTechniques.init();

}
